export const hazardStatements = {
  H200: 'Unstable explosive',
  H201: 'Explosive; mass explosion hazard',
  H202: 'Explosive; severe projection hazard',
  H203: 'Explosive; fire, blast or projection hazard',
  H204: 'Fire or projection hazard',
  H205: 'May mass explode in fire',
  H220: 'Extremely flammable gas',
  H221: 'Flammable gas',
  H222: 'Extremely flammable aerosol',
  H223: 'Flammable aerosol',
  H224: 'Extremely flammable liquid and vapour',
  H225: 'Highly flammable liquid and vapour',
  H226: 'Flammable liquid and vapour',
  H227: 'Combustible liquid',
  H228: 'Flammable solid',
  H229: 'Pressurized container: may burst if heated',
  H230: 'May react explosively even in the absence of air',
  H231: 'May react explosively even in the absence of air at elevated pressure and/or temperature',
  H240: 'Heating may cause an explosion',
  H241: 'Heating may cause a fire or explosion',
  H242: 'Heating may cause a fire',
  H250: 'Catches fire spontaneously if exposed to air',
  H251: 'Self-heating; may catch fire',
  H252: 'Self-heating in large quantities; may catch fire',
  H260: 'In contact with water releases flammable gases which may ignite spontaneously',
  H261: 'In contact with water releases flammable gas',
  H270: 'May cause or intensify fire; oxidizer',
  H271: 'May cause fire or explosion; strong oxidizer',
  H272: 'May intensify fire; oxidizer',
  H280: 'Contains gas under pressure; may explode if heated',
  H281: 'Contains refrigerated gas; may cause cryogenic burns or injury',
  H290: 'May be corrosive to metals',
  H300: 'Fatal if swallowed',
  H301: 'Toxic if swallowed',
  H302: 'Harmful if swallowed',
  H303: 'May be harmful if swallowed',
  H304: 'May be fatal if swallowed and enters airways',
  H305: 'May be harmful if swallowed and enters airways',
  H310: 'Fatal in contact with skin',
  H311: 'Toxic in contact with skin',
  H312: 'Harmful in contact with skin',
  H313: 'May be harmful in contact with skin',
  H314: 'Causes severe skin burns and eye damage',
  H315: 'Causes skin irritation',
  H316: 'Causes mild skin irritation',
  H317: 'May cause an allergic skin reaction',
  H318: 'Causes serious eye damage',
  H319: 'Causes serious eye irritation',
  H320: 'Causes eye irritation',
  H330: 'Fatal if inhaled',
  H331: 'Toxic if inhaled',
  H332: 'Harmful if inhaled',
  H333: 'May be harmful if inhaled',
  H334: 'May cause allergy or asthma symptoms or breathing difficulties if inhaled',
  H335: 'May cause respiratory irritation',
  H336: 'May cause drowsiness or dizziness',
  H340: 'May cause genetic defects',
  H341: 'Suspected of causing genetic defects',
  H350: 'May cause cancer',
  H351: 'Suspected of causing cancer',
  H360: 'May damage fertility or the unborn child',
  H361: 'Suspected of damaging fertility or the unborn child',
  H361d: 'Suspected of damaging the unborn child',
  H362: 'May cause harm to breast-fed children',
  H370: 'Causes damage to organs',
  H371: 'May cause damage to organs',
  H372: 'Causes damage to organs through prolonged or repeated exposure',
  H373: 'May cause damage to organs through prolonged or repeated exposure',
  H400: 'Very toxic to aquatic life',
  H401: 'Toxic to aquatic life',
  H402: 'Harmful to aquatic life',
  H410: 'Very toxic to aquatic life with long lasting effects',
  H411: 'Toxic to aquatic life with long lasting effects',
  H412: 'Harmful to aquatic life with long lasting effects',
  H413: 'May cause long lasting harmful effects to aquatic life',
  H420: 'Harms public health and the environment by destroying ozone in the upper atmosphere',
  EUH001: 'Explosive when dry',
  EUH006: 'Explosive with or without contact with air',
  EUH014: 'Reacts violently with water',
  EUH018: 'In use may form flammable/explosive vapour-air mixture',
  EUH019: 'May form explosive peroxides',
  EUH044: 'Risk of explosion if heated under confinement',
  EUH029: 'Contact with water liberates toxic gas',
  EUH031: 'Contact with acids liberates toxic gas',
  EUH032: 'Contact with acids liberates very toxic gas',
  EUH066: 'Repeated exposure may cause skin dryness or cracking',
  EUH070: 'Toxic by eye contact',
  EUH071: 'Corrosive to the respiratory tract',
  EUH059:
    'Hazardous to the ozone layer, superseded by GHS Class 5.1 in the second adaptation to technical progress of CLP.',
  EUH201:
    'Contains lead. Should not be used on surfaces liable to be chewed or sucked by children.',
  EUH201A: 'Warning! Contains lead.',
  EUH202:
    'Cyanoacrylate. Danger. Bonds skin and eyes in seconds. Keep out of the reach of children.',
  EUH203: 'Contains chromium(VI). May produce an allergic reaction.',
  EUH204: 'Contains isocyanates. May produce an allergic reaction.',
  EUH205: 'Contains epoxy constituents. May produce an allergic reaction.',
  EUH206:
    'Warning! Do not use together with other products. May release dangerous gases (chlorine).',
  EUH207:
    'Warning! Contains cadmium. Dangerous fumes are formed during use. See information supplied by the manufacturer. Comply with the safety instructions.',
  EUH208:
    'Contains <name of sensitising substance>. May produce an allergic reaction.',
  EUH209: 'Can become highly flammable in use.',
  EUH209A: 'Can become flammable in use.',
  EUH210: 'Safety data sheet available on request.',
  EUH401:
    'To avoid risks to human health and the environment, comply with the instructions for use.',
};
